import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomeScreen from "./components/HomeScreen";
import ProjectScreen from "./components/ProjectScreen";
import NotFoundScreen from "./components/NotFoundScreen";
import ScrollToTop from "./components/ScrollToTop";
import CanonicalUrl from "./components/CanonicalUrl";

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <CanonicalUrl />
      <Routes>
        <Route path="/" element={<HomeScreen />} />
        {/*
          The slug lives in the URL rather than in router state, so a project
          page survives a refresh and can be shared as a link.
        */}
        <Route path="/projects/:slug" element={<ProjectScreen />} />
        <Route path="*" element={<NotFoundScreen />} />
      </Routes>
    </BrowserRouter>
  );
}
